<template>
  <section class="ugc" ref="ugc">
    <div class="w-full bg-black pt-30 lg:pt-0 lg:px-0 px-16 h-11/15-screen lg:h-auto">
      <div class="h-1/2 bg-black w-full blex flex-wrap">
        <div class="w-full lg:w-1/2-vw blex flex-wrap lg:flex-no-wrap pt-0 pb-0 lg:py-60">
          <div class="blex-left lg:blex w-full lg:mb-0 mb-12">
            <div class="text-white font-bold text-2xl lg:text-6xl blex bottom-gradient pb-12">
              UGC
            </div>
          </div>
          <div class="blex-left">
            <div class="text-white font-medium text-2xs lg:text-base pb-8 lg:pb-30-vw leading-xs">
              {{ $t('ugc.1') }}<br class="hidden lg:block">
              {{ $t('ugc.2') }}
            </div>
            <div class="text-white font-medium text-2xs lg:text-base leading-xs">
              {{ $t('ugc.3') }}
            </div>
          </div>
        </div>
      </div>

      <div class="h-1/2 px-16 lg:px-0 mx-auto w-full lg:w-7/10 blex lg:flex-no-wrap pb-0 items-start">

        <!--  circle     -->
        <div class="blex relative">
          <!--  ugc object      -->
          <div class="blex">
            <img :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/ugc.png') : require('@/assets/images/pages/main/ugc/mUgc.png')" class="ugc-object">
          </div>

          <!--   @todo: 경복궁에 animaiton 적용 'on'class 추가       -->
          <div class="circle-wrapper">
            <div class="inner"></div>
            <div class="ugc-circle1 circle"></div>
            <div class="ugc-circle2 circle"></div>
            <div class="ugc-circle3 circle"></div>
          </div>

          <!--   @todo: 빌딩에 animaiton 적용 'on'class 추가       -->
          <div class="circle-wrapper2">
            <div class="inner2"></div>
            <div class="ugc-circle4 circle"></div>
            <div class="ugc-circle5 circle"></div>
            <div class="ugc-circle6 circle"></div>
          </div>
        </div>

        <!-- @todo : vue-twentytwenty 적용     -->
        <div class="ugc-image-wrapper">
          <!--  ugc 렌더링 전 이미지     -->

          <div class="ugc-images first">
            <div class="ugc-image before">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/ugc1.png') : require('@/assets/images/pages/main/ugc/mUgc1.png')"
                  class="w-full">
            </div>
            <!--  ugc 렌더링 후 이미지     -->
            <div class="ugc-image after">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/ugc2.png') : require('@/assets/images/pages/main/ugc/mUgc2.png')"
                  class="w-full">
            </div>
          </div>

          <div class="ugc-images second">
            <!--  ugc 렌더링 전 이미지     -->
            <div class="ugc-image before">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/GyeongbokPalace1.png') : require('@/assets/images/pages/main/ugc/mGyeongbokPalace1.png')"
                  class="w-full">
            </div>
            <div class="ugc-image after after1">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/GyeongbokPalace2.png') : require('@/assets/images/pages/main/ugc/mGyeongbokPalace2.png')"
                  class="w-full">
            </div>
            <div class="ugc-image after after2">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/GyeongbokPalace3.png') : require('@/assets/images/pages/main/ugc/mGyeongbokPalace3.png')"
                  class="w-full">
            </div>
            <div class="ugc-image after after3">
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/ugc/GyeongbokPalace4.png') : require('@/assets/images/pages/main/ugc/mGyeongbokPalace4.png')"
                  class="w-full">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
let timeline = null
export default {
  name: 'Ugc',
  data: () => ({
    timeline: null
  }),
  methods: {
    animations() {
      // this.$scrollTrigger.saveStyles(
      //     '.rot-images-wrapper, .description, .rot-images, section.pte, .desc'
      // )
      this.$scrollTrigger.matchMedia({
        '(min-width: 1025px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }
          timeline = this.initAnimations()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        },
        '(max-width: 1024px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }

          timeline = this.initAnimationsM()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        }
      })
    },
    initAnimations() {
      const timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: 'section.ugc',
          scroller: '#index',
          start: 'top',
          end: '700%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      timeline.fromTo('.ugc-images.first .ugc-image.after', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.first .ugc-image.after img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').to('.circle-wrapper2', {
        className: 'circle-wrapper2 on',
        duration: 1
      }, '-=1').to('.circle-wrapper2', {
        className: 'circle-wrapper2',
        duration: 1
      }).to('.circle-wrapper', {
        className: 'circle-wrapper on',
        duration: 1
      }, '-=1').to('.ugc-images.second', {
        opacity: 1,
        duration: 1
      }, '-=1').to('.ugc-images.first', {
        opacity: 0
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after1', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.second .ugc-image.after1 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after2', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after2 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after3', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.second .ugc-image.after3 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1')


      return timeline
    },
    initAnimationsM() {
      const timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: 'section.ugc',
          scroller: '#index',
          start: 'top',
          end: '350%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      timeline.fromTo('.ugc-images.first .ugc-image.after', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.first .ugc-image.after img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').to('.circle-wrapper2', {
        className: 'circle-wrapper2 on',
        duration: 1
      }, '-=1').to('.circle-wrapper2', {
        className: 'circle-wrapper2',
        duration: 1
      }).to('.circle-wrapper', {
        className: 'circle-wrapper on',
        duration: 1
      }, '-=1').to('.ugc-images.second', {
        opacity: 1,
        duration: 1
      }, '-=1').to('.ugc-images.first', {
        opacity: 0
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after1', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.second .ugc-image.after1 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after2', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after2 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1').fromTo('.ugc-images.second .ugc-image.after3', {
        y: 0,
        xPercent: 100
      }, {
        xPercent: 0,
        duration: 1
      }).fromTo('.ugc-images.second .ugc-image.after3 img', {
        y: 0,
        xPercent: -100
      }, {
        xPercent: 0,
        duration: 1
      }, '-=1')

      return timeline
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  display: flex;
  align-items: center;
  height: calc(var(--vh) * 100);

  @media screen and (max-width: 1024px) {
    align-items: start;
  }

  .ugc-object {
    width: 28.646vw;
    @media screen and (max-width: 1024px) {
      //width: 200px;
      width: 50%;
    }
  }

  .circle-wrapper {
    &.on {
      position: absolute;
      left: 35%;
      top: 30%;
      width: 16.667vw;
      height: 16.667vw;
      z-index: 2;
      background: url("~@/assets/images/pages/main/ugc/circle1.svg");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .inner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 15.625vw;
        height: 15.625vw;
        background: url("~@/assets/images/pages/main/ugc/circle2.svg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      .circle {
        position: absolute;
        border-radius: 100%;
        background-color: #fff;
        transform-origin: -6.250vw 5.208vw;
        box-shadow: 0px 0px 10px #FFFFFF;
      }

      .ugc-circle1 {
        top: 19%;
        left: 87%;
        transform: translateX(-50%, -50%);
        width: 6px;
        height: 6px;
        animation: aroundCircle1 8s linear infinite;
      }

      .ugc-circle2 {
        right: 10%;
        top: 19%;
        transform: translateX(85%);
        width: 8px;
        height: 8px;
        animation: aroundCircle2 4s linear infinite;
      }

      .ugc-circle3 {
        top: 19%;
        left: 85.5%;
        transform: translateX(-85%);
        width: 12px;
        height: 12px;
        animation: aroundCircle2 6s linear infinite;
      }

      @media screen and (max-width: 1024px) {
        left: 36%;
        top: 20%;
        width: 120px;
        height: 120px;

        .inner {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100px;
          height: 100px;
        }

        .circle {
          transform-origin: -44px 38px;
        }

        .ugc-circle1 {
          top: 19%;
          left: 87%;
          width: 3px;
          height: 3px;
          animation: aroundCircle1 8s linear infinite;
        }

        .ugc-circle2 {
          right: 10%;
          top: 19%;
          transform: translateX(85%);
          width: 6px;
          height: 6px;
          animation: aroundCircle2 4s linear infinite;
        }

        .ugc-circle3 {
          top: 19%;
          left: 85.5%;
          transform: translateX(-85%);
          width: 8px;
          height: 8px;
          animation: aroundCircle2 6s linear infinite;
        }

      }

    }

    @keyframes aroundCircle1 {

      0% {
        transform: rotateZ(360deg);
      }

      100% {
        transform: rotateZ(-360deg);
      }
    }

    @keyframes aroundCircle2 {

      0% {
        transform: rotateZ(-180deg);
      }

      100% {
        transform: rotateZ(180deg);
      }
    }

  }

  .circle-wrapper2 {
    &.on {
      position: absolute;
      left: 10%;
      top: 5%;
      width: 16.667vw;
      height: 16.667vw;
      z-index: 2;
      background: url("~@/assets/images/pages/main/ugc/circle1.svg");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .inner2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 15.625vw;
        height: 15.625vw;
        background: url("~@/assets/images/pages/main/ugc/circle2.svg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      .circle {
        position: absolute;
        border-radius: 100%;
        background-color: #fff;
        transform-origin: -6.250vw 5.208vw;
        box-shadow: 0px 0px 10px #FFFFFF;
      }

      .ugc-circle4 {
        top: 19%;
        left: 87%;
        transform: translateX(-50%, -50%);
        width: 6px;
        height: 6px;
        animation: aroundCircle1 8s linear infinite;
      }

      .ugc-circle5 {
        right: 10%;
        top: 19%;
        transform: translateX(85%);
        width: 8px;
        height: 8px;
        animation: aroundCircle2 4s linear infinite;
      }

      .ugc-circle6 {
        top: 19%;
        left: 85.5%;
        transform: translateX(-85%);
        width: 12px;
        height: 12px;
        animation: aroundCircle2 6s linear infinite;
      }

      @keyframes aroundCircle1 {

        0% {
          transform: rotateZ(360deg);
        }

        100% {
          transform: rotateZ(-360deg);
        }
      }

      @keyframes aroundCircle2 {

        0% {
          transform: rotateZ(-180deg);
        }

        100% {
          transform: rotateZ(180deg);
        }
      }

      @media screen and (max-width: 1024px) {
        left: 25%;
        top: -5%;
        width: 120px;
        height: 120px;

        .inner2 {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100px;
          height: 100px;
        }

        .circle {
          transform-origin: -44px 38px;
        }

        .ugc-circle4 {
          top: 19%;
          left: 87%;
          width: 3px;
          height: 3px;
          animation: aroundCircle1 8s linear infinite;
        }

        .ugc-circle5 {
          right: 10%;
          top: 19%;
          transform: translateX(85%);
          width: 6px;
          height: 6px;
          animation: aroundCircle2 4s linear infinite;
        }

        .ugc-circle6 {
          top: 19%;
          left: 85.5%;
          transform: translateX(-85%);
          width: 8px;
          height: 8px;
          animation: aroundCircle2 6s linear infinite;
        }
      }
    }
  }

  .ugc-image-wrapper {
    width: 100%;


    .ugc-images {
      position: relative;
      width: 100%;
      float: left;
      margin-left: 50px;

      .ugc-image {
        position: absolute;
        top: 0;
        width: 39.583vw;
        overflow: hidden;


        &.after {
          overflow: hidden;
          transform: translate(0, 100%);

          img {
            transform: translate(0, -100%);
          }
        }
      }

      &.second {
        opacity: 0;
      }

      @media screen and (max-width: 1024px) {
        margin-left: 0;
        .ugc-image {
          width: 100%;
        }
      }
    }
  }
}

</style>
